import { Input, TextareaAutosize, Typography } from "@mui/material";
import React, { useEffect } from "react";

const FalAiViduSettings = ({
  onSettingsChange,
  selectedPrompt,
  generateExact,
}) => {
  const [settings, setSettings] = React.useState({
    prompt: selectedPrompt?.prompt || "",
    negativePrompt: "",
    seed: generateExact ? selectedPrompt?.seed : "",
    aspect_ratio: "16:9",
    movement_amplitude: "auto",
  });
  useEffect(() => {
    // Update settings when selectedPrompt changes
    if (selectedPrompt?.prompt) {
      setSettings((prevSettings) => ({
        ...prevSettings,
        prompt: selectedPrompt?.prompt,
      }));
    } else {
      setSettings((prevSettings) => ({
        ...prevSettings,
        prompt: "",
      }));
    }
  }, [selectedPrompt?.prompt]);
  useEffect(() => {
    // Update settings when selectedPrompt changes
    if (selectedPrompt?.prompt) {
      setSettings((prevSettings) => ({
        ...prevSettings,
        seed: generateExact ? selectedPrompt?.seed : "",
      }));
    }
  }, [selectedPrompt?.seed, generateExact]);
  useEffect(() => {
    // Call onSettingsChange when component mounts to set initial settings
    onSettingsChange?.(settings);
  }, [settings]);
  const handleSettingChange = (key, value) => {
    const newSettings = { ...settings, [key]: value };
    setSettings(newSettings);
    onSettingsChange?.(newSettings);
  };
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <Typography className="text-gray-300">Aspect Ratio</Typography>
          <select
            value={settings.aspect_ratio}
            onChange={(e) =>
              handleSettingChange("aspect_ratio", e.target.value)
            }
            className="w-full p-2 bg-gray-700 border border-gray-600 rounded text-white"
          >
            <option value="16:9">16:9 (Widescreen)</option>
            <option value="9:16">9:16 (Portrait)</option>
            <option value="1:1">1:1 (Square)</option>
            <option value="4:3">4:3 (Classic)</option>
          </select>
          <p className="text-xs text-gray-400 mt-1">
            Output video aspect ratio
          </p>
        </div>
        <div>
          <Typography className="text-gray-300">Movement Amplitude</Typography>
          <select
            value={settings.movement_amplitude}
            onChange={(e) =>
              handleSettingChange("movement_amplitude", e.target.value)
            }
            className="w-full p-2 bg-gray-700 border border-gray-600 rounded text-white"
          >
            <option value="auto">Auto</option>
            <option value="small">Small</option>
            <option value="medium">Medium</option>
            <option value="large">Large</option>
          </select>
          <p className="text-xs text-gray-400 mt-1">
            Controls the intensity of motion
          </p>
        </div>
      </div>
      <div>
        <Typography className="text-gray-300">Prompt</Typography>
        <TextareaAutosize
          className="w-full p-2 bg-gray-700 border border-gray-600 rounded text-white resize-none"
          rows={3}
          placeholder="Describe the motion you want to see in the video..."
          onChange={(e) => handleSettingChange("prompt", e.target.value)}
          value={settings.prompt}
        />
        <p className="text-xs text-gray-400 mt-1">
          Describe the motion you want to see in the video
        </p>
      </div>

      <div>
        <Typography className="text-gray-300">Negative Prompt</Typography>
        <TextareaAutosize
          className="w-full p-2 bg-gray-700 border border-gray-600 rounded text-white resize-none"
          rows={2}
          placeholder="What you don't want in the result..."
          onChange={(e) =>
            handleSettingChange("negativePrompt", e.target.value)
          }
          value={settings.negativePrompt}
        />
        <p className="text-xs text-gray-400 mt-1">
          Describe what should be avoided
        </p>
      </div>
      <div>
        <Typography className="text-gray-300">Seed</Typography>
        <Input
          type="text"
          value={settings.seed}
          onChange={(e) => handleSettingChange("seed", e.target.value)}
          className="w-full p-2 bg-gray-700 border border-gray-600 rounded text-white"
          placeholder="Leave empty for random seed"
        />
        <p className="text-xs text-gray-400 mt-1">
          Controls the initial noise pattern
        </p>
      </div>
    </div>
  );
};
export default FalAiViduSettings;
